import type { FormField, FormSchema } from '@cli-types/core-engine/schema.js'

export function generateMailchimpCode(schema: FormSchema, fields: FormField[]): string {
  if (!schema.mailchimp) return ''

  let emailFieldName: string
  if (typeof schema.mailchimp === 'object' && schema.mailchimp.emailField) {
    emailFieldName = schema.mailchimp.emailField
  } else {
    const emailField = fields.find((f) => f.type === 'email')
    if (!emailField || !emailField.name) {
      console.warn(
        `Warning: Form "${schema.name}" has mailchimp enabled but no email field found. Skipping.`
      )
      return ''
    }
    emailFieldName = emailField.name
  }

  return `\n    addToMailchimpAudience(data.${emailFieldName})`
}
